export const BROKER_PORTAL_SELF_SERVE_UW_OFFER = 'Self Serve';

export const DEFAULT_INITIAL_PLAN_NAME = 'Plan 1';

export const OPENL_DEFAULTS_CONFIG_DATE = '2026-02-13T00:00:00.000Z';
